import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./topCategories.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { navigateEvent } from '~/modules/helpers/navigationHelper';
import { contentStore, selectCategoryFeed } from '~/modules/stores/contentStore';
import { i18nStore } from '~/modules/stores/i18nStore';
class TopCategories extends LightningElement {
  constructor(...args) {
    super(...args);
    // TODO: We must relocate the data we cache in this component to a store, preferably contentStore.
    this.store = {
      isLoading: true,
      isError: false,
      isEmpty: true,
      records: []
    };
    this._props = {};
  }
  set props(value) {
    this._props = value;
    this.fetchRecords();
  }
  get props() {
    return this._props;
  }
  setRecords(data) {
    if (data) {
      const {
        isEmpty,
        isError,
        records
      } = data;
      const recordsWithAriaLabel = this.getRecordsWithAriaLabel(records);
      this.store = {
        isLoading: false,
        // @ts-expect-error * Automated Type Error Fix
        records: recordsWithAriaLabel,
        isEmpty,
        isError
      };
    } else {
      this.store.isLoading = false;
      this.store.isError = true;
    }
  }
  get showCategories() {
    return !this.store.isEmpty || !this.store.isError;
  }
  get storeName() {
    return 'category';
  }
  getRecordsWithAriaLabel(records) {
    return records.map(record => {
      const ariaLabel = i18nStore.getState()
      // @ts-expect-error * Automated Type Error Fix
      .i18n.shared.tagAriaLabel({
        CATEGORY_NAME: record.callToAction.name
      });
      return {
        ...record,
        ariaLabel
      };
    }) || [];
  }
  handleClick(event) {
    const button = event.target;
    if (button.props?.callToAction?.url) {
      const url = button.props?.callToAction?.url;
      navigateEvent(url, event);
    }
  }
  handleAnalytics(event) {
    event.detail.topCategories = this.props;
  }
  fetchRecords() {
    // If url is not comming use friendly url
    const url = this.props.url ? this.props.url : '/home_content/category';
    contentStore.fetchFeeds(url, this.storeName);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(TopCategories, {
  publicProps: {
    props: {
      config: 3
    }
  },
  track: {
    store: 1
  },
  wire: {
    setRecords: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: contentStore,
          selector: selectCategoryFeed
        };
      }
    }
  },
  fields: ["_props"]
});
const __lwc_component_class_internal = _registerComponent(TopCategories, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;